type RecordItem = Record<string, any>;
type RecordQuery = Record<string, unknown>;
export const RECORD_SIZE_LIMIT = 3 * 1024 * 1024;
export class RecordSizeLimitError extends Error {}
export interface RecordPage {
  Items?: RecordItem[];
  LastEvaluatedKey?: Record<string, unknown>;
}

export async function collectCsvRecords(
  queries: RecordQuery[],
  fetchPage: (query: RecordQuery) => Promise<RecordPage>,
): Promise<RecordItem[]> {
  const records: RecordItem[] = [];
  const seen = new Set<string>();
  let bytes = 0;

  for (const query of queries) {
    let cursor: RecordPage['LastEvaluatedKey'];
    do {
      const page = await fetchPage({...query, ...(cursor ? {ExclusiveStartKey: cursor} : {})});
      const items = page.Items || [];
      bytes += new Blob([JSON.stringify(items)]).size;
      if (bytes >= RECORD_SIZE_LIMIT) throw new RecordSizeLimitError();
      cursor = page.LastEvaluatedKey;
      if (cursor && Object.keys(cursor).length === 0) cursor = undefined;

      for (const item of items) {
        // The legacy date-format query may return the same records as the standard query.
        const key = item.DEVICE_ID?.S && item.CREATE_AT?.S
          ? JSON.stringify([item.DEVICE_ID.S, item.CREATE_AT.S])
          : JSON.stringify(item);
        if (!seen.has(key)) {
          seen.add(key);
          records.push(item);
        }
      }
    } while (cursor);
  }
  return records;
}
